import { render, staticRenderFns } from "./BranchInboundDestinationTab.vue?vue&type=template&id=7372d719&scoped=true"
import script from "./BranchInboundDestinationTab.vue?vue&type=script&lang=js"
export * from "./BranchInboundDestinationTab.vue?vue&type=script&lang=js"
import style0 from "./BranchInboundDestinationTab.vue?vue&type=style&index=0&id=7372d719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7372d719",
  null
  
)

export default component.exports